
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 110 80"}},[_c('path',{attrs:{"d":"M0 0v80h110V0H0zm55 48.6L8.2 5h93.6L55 48.6zM34.5 36.3L5 71.6V8.9l29.5 27.4zm3.6 3.4L55 55.4l16.9-15.7L101.3 75H8.7l29.4-35.3zm37.4-3.4L105 8.9v62.7L75.5 36.3z"}})])
      }
    
      }
    